import styled from "@emotion/styled";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import theme from "../theme";
import { Button } from "./common/Button";
import { useWindowSize } from "@reactuses/core";

const { md } = theme.screen;

export const CustomAlert: React.FC<{
  open: boolean;
  onPressOK?: () => void;
  title: string;
  content: string;
  content2?: string;
  content3?: string;
  confirmText: string;
  icon: JSX.Element;
}> = (props) => {
  const {
    open,
    onPressOK,
    title,
    content,
    content2,
    content3,
    confirmText,
    icon,
  } = props;
  const { width } = useWindowSize();
  return (
    <Dialog
      open={open}
      onClose={onPressOK}
      PaperProps={{
        sx: {
          width: { xs: "90%", sm: "513px" },
          maxWidth: { xs: "90%", sm: "513px" },
          minWidth: { xs: "320px", sm: "513px" },
          alignItems: "center",
          pt: "50px",
          borderRadius: "20px",
          pb: "65px",
        },
      }}
    >
      {icon}
      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: { xs: "18px", sm: "20px" },
          lineHeight: "23px",
          mt: "14px",
          mb: "15px",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DialogContentText
          sx={{
            width: "100%",
            marginX: {
              xs: "auto",
            },
            fontWeight: 400,
            fontSize: { xs: "14px", sm: "15px" },
            lineHeight: "18px",
            color: theme.color.neutral_600,
            whiteSpace: "pre-line",
            textAlign: "center",
            mb: "30px",
          }}
        >
          <Content>{content}</Content>
          <Content>{content2}</Content>
          <Content>{content3}</Content>
        </DialogContentText>
      </DialogContent>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          if (onPressOK) {
            onPressOK();
          }
        }}
      >
        <Button
          autoFocus
          bgColor={theme.statusColor.MAIN}
          color={theme.color.white}
          hoverColor={theme.statusColor.MAIN_HOVER}
          style={{ width: width <= md ? "100%" : "330px", height: "50px" }}
          type="submit"
        >
          {confirmText}
        </Button>
      </Form>
    </Dialog>
  );
};

const Content = styled.span`
  line-height: 22px;
`;

const Form = styled.form`
  width: 100%;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
